// Action types
export const BACKEND_AUTHENTICATION_ERROR = 'BACKEND_AUTHENTICATION_ERROR';
export const BACKEND_SERVICE_ERROR = 'BACKEND_SERVICE_ERROR';
export const GET_ENROLLMENT_DATA_FAILURE = 'GET_ENROLLMENT_DATA_FAILURE';
export const GET_ENROLLMENT_DATA_SUCCESS = 'GET_ENROLLMENT_DATA_SUCCESS';
export const NO_CHAPTER33_RECORD_AVAILABLE = 'NO_CHAPTER33_RECORD_AVAILABLE';
export const SERVICE_DOWNTIME_ERROR = 'SERVICE_DOWNTIME_ERROR';
